import { Card, CardContent } from "../ui/card";
import { Clock, CheckCircle2, BookUser } from "lucide-react";

export function StatsCards({ pendingCount, completedCount, contactsCount }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-4 mt-6">
        <Card className="border-0 shadow-[0_2px_8px_rgba(0,0,0,0.08)] bg-blue-50">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
                <Clock className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-blue-700">{pendingCount}</p>
                <p className="text-xs text-blue-600">Pending</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="border-0 shadow-[0_2px_8px_rgba(0,0,0,0.08)] bg-green-50">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
                <CheckCircle2 className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-2xl font-bold text-green-700">{completedCount}</p>
                <p className="text-xs text-green-600">Completed</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card className="border-0 shadow-[0_2px_8px_rgba(0,0,0,0.08)] bg-purple-50 mt-4">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-purple-500 flex items-center justify-center">
              <BookUser className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-2xl font-bold text-purple-700">{contactsCount}</p>
              <p className="text-xs text-purple-600">Saved Contacts</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
